'use strict'
import {
    formateQuery
} from './formate'

function List(params) {
    // 播放列表
    this.list = [];
    this.currentIndex = -1;
    this.randomIndexArr = [];
    // 循环模式(single,list,random,none)
    this.mode = 'list';
    // 绑定事件，回调函数池
    this.eventsPool = {};

    // =================== 初始化
    let _that = this;
    (function () {
        // 默认初始值
        let conf = {
            ele: document.body,
            mode: 'list',
            theme: 'none',
            cut:()=>{},
            change:()=>{},
        }
        // 合并传参
        conf = formateQuery(conf, params);

        // 缓存：循环模式
        _that.mode = conf.mode;
        // 监听事件
        _that.on('cut',conf.cut);
        _that.on('change',conf.change);
    })()
}

List.prototype = {
    constructor: List,

    get(index) {
        if (!index || index < 0 || index > this.list.length - 1) {
            return this.list
        }
        return this.list[index]
    },
    add(data) {
        const conf = {
            url: data.url || '',
            singer: data.singer || '<未知>',
            title: data.title || '<未知>',
            desc: data.desc || ''
        }
        if (data.url) {
            for (let key in data) {
                if (conf.hasOwnProperty(key)) {
                    conf[key] = data[key];
                }
            }
            this.list.push(conf);
        }

        // 特殊情况：列表第一首，“切歌”
        if(this.currentIndex == -1 && this.list.length == 1){
            this.next();
        }

        this.trigger('change', this.list)
    },
    del(index) {
        if (index < 0 || index > this.list.length - 1) {
            return
        }

        this.list.splice(index, 1)
        // 更新随机模式缓存<Array>randomIndexArr
        let i = this.randomIndexArr.indexOf(index);
        if (i >= 0) {
            this.randomIndexArr.splice(i, 1);
        }
        // 更新当前播放下标currentIndex
        if (this.currentIndex > index) {
            // 同上
            let j = this.randomIndexArr.indexOf(this.currentIndex);
            if (j >= 0) {
                this.randomIndexArr[j] -= 1;
            }
            this.currentIndex -= 1;
        } else if (this.currentIndex == index) {
            // 当前播放：“切歌”
            this.next()
        }

        this.trigger('change', this.list)
    },
    replace(fromIndex, toIndex) {
        if (fromIndex == toIndex || fromIndex < 0 || fromIndex > this.list.length - 1 || toIndex < 0 || toIndex > this.list.length - 1) {
            return
        }

        let temp = this.list[toIndex];
        this.list[toIndex] = this.list[fromIndex];
        this.list[fromIndex] = temp;

        // 更新当前播放下标currentIndex
        if (this.currentIndex == fromIndex) {
            this.currentIndex = toIndex;
        }
        if (this.currentIndex == toIndex) {
            this.currentIndex = fromIndex;
        }
        // 更新随机模式缓存<Array>randomIndexArr
        let i = this.randomIndexArr.indexOf(fromIndex);
        let j = this.randomIndexArr.indexOf(toIndex);
        if (i >= 0) {
            this.randomIndexArr[i] = toIndex;
        }
        if (j >= 0) {
            this.randomIndexArr[j] = fromIndex;
        }

        this.trigger('change', this.list)
    },
    clear() {
        this.list = []
        this.currentIndex = -1
        this.randomIndexArr = [];

        this.trigger('change', this.list)
    },
    mode(action){
        if(/^(single|list|random|none)$/.test(action)){
            this.mode = action;
        }
    },
    next() {
        if (this.list.length < 1) {
            return
        }
        if (this.mode == 'list' || this.mode == 'single') {
            if (this.currentIndex >= this.list.length - 1) {
                this.currentIndex = 0;
            } else {
                this.currentIndex += 1
            }
        } else if (this.mode == 'random') {
            // 生成随机数
            this.currentIndex = this.randomIndex();
        } else if (this.mode == 'none') {
            if (this.currentIndex >= this.list.length - 1) {
                return
            } else {
                this.currentIndex += 1
            }
        }
        
        this.trigger('cut', {index:this.currentIndex,song:this.list[this.currentIndex]})
        return this.currentIndex;
    },
    nextTo(index){
        if (this.list.length < 1 || index < 0 || index > this.list.length - 1) {
            return
        }

        this.currentIndex = index;

        if(this.mode == 'random'){
            if(this.randomIndexArr.length >= this.list.length){
                this.randomIndexArr = [];
            }
            if(this.randomIndexArr.indexOf(index) < 0){
                this.randomIndexArr.push(index);
            }
        }
        this.trigger('cut', {index,song:this.list[index]})
        // this.trigger('cut', this.list[index])
        return this.currentIndex;
    },
    prev() {
        if (this.list.length < 1) {
            return
        }
        if (this.mode == 'list' || this.mode == 'single') {
            if (this.currentIndex == 0 || this.currentIndex >= this.list.length) {
                this.currentIndex = this.list.length - 1
            } else {
                this.currentIndex -= 1
            }
        } else if (this.mode == 'random') {
            // 随机
            this.currentIndex = this.randomIndex();
        } else if (this.mode == 'none') {
            if (this.currentIndex == 0) {
                return
            } else {
                this.currentIndex -= 1
            }
        }
        this.trigger('cut', {index:this.currentIndex,song:this.list[this.currentIndex]})
        // this.trigger('cut', this.list[this.currentIndex])
        return this.currentIndex;
    },

    randomIndex() {
        let lengthList = this.list.length;
        let temp = Math.round(Math.random() * (lengthList - 1));
        if (lengthList <= this.randomIndexArr.length) {
            this.randomIndexArr = [];
        }
        // 特殊情况：清空后第一个不能重复,list至少2个
        if (this.randomIndexArr.indexOf(temp) >= 0 || (this.currentIndex == temp && lengthList >= 2)) {
            return this.randomIndex();
        }
        this.randomIndexArr.push(temp);
        return temp;
    },
    on(name, callback) {
        if (/^(cut|change)$/.test(name)) {
            if (typeof callback === 'function') {
                if (!this.eventsPool[name]) {
                    this.eventsPool[name] = [];
                }
                this.eventsPool[name].push(callback);
            }
        }
    },
    trigger(name, data) {
        if (/^(cut|change)$/.test(name)) {
            if (this.eventsPool[name] && this.eventsPool[name].length) {
                for (let i = 0; i < this.eventsPool[name].length; i++) {
                    this.eventsPool[name][i](data);
                }
            }
        }
    },
}

export default List